import { render, staticRenderFns } from "./EnterDomainCard.vue?vue&type=template&id=527ed8e3&scoped=true&"
import script from "./EnterDomainCard.vue?vue&type=script&lang=js&"
export * from "./EnterDomainCard.vue?vue&type=script&lang=js&"
import style0 from "./EnterDomainCard.vue?vue&type=style&index=0&id=527ed8e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527ed8e3",
  null
  
)

export default component.exports